export function renderOg(): void {
  const canvas = document.createElement('canvas');
  canvas.id = 'og-canvas';
  canvas.width = 1200;
  canvas.height = 630;
  const ctx = canvas.getContext('2d')!;
  ctx.fillStyle = '#f4ad72'; ctx.fillRect(0, 0, 1200, 630);
  ctx.fillStyle = '#ffd482'; ctx.beginPath(); ctx.arc(980, 95, 115, 0, Math.PI * 2); ctx.fill();
  ctx.fillStyle = '#34316f'; ctx.beginPath(); ctx.moveTo(715, 70); ctx.lineTo(1200, 70); ctx.lineTo(1200, 630); ctx.lineTo(640, 630); ctx.closePath(); ctx.fill();
  ctx.strokeStyle = '#fff6dc'; ctx.lineWidth = 8; ctx.beginPath(); ctx.moveTo(920, 70); ctx.lineTo(880, 630); ctx.stroke();
  ctx.beginPath(); ctx.arc(970, 435, 235, Math.PI * 1.12, Math.PI * 1.9); ctx.stroke();
  drawPlayer(ctx, 860, 385, '#ff7548', false);
  drawPlayer(ctx, 1015, 300, '#b7e875', true);
  drawBall(ctx, 825, 245, 42);
  ctx.strokeStyle = 'rgba(255,246,220,.75)'; ctx.lineWidth = 6; ctx.setLineDash([16, 16]);
  ctx.beginPath(); ctx.moveTo(830, 240); ctx.quadraticCurveTo(985, 72, 1130, 190); ctx.stroke(); ctx.setLineDash([]);

  ctx.fillStyle = '#242251'; ctx.fillRect(46, 44, 154, 36);
  ctx.fillStyle = '#fff6dc'; ctx.font = '800 19px Inter, sans-serif'; ctx.letterSpacing = '3px'; ctx.fillText('PLAYKEG', 66, 69);
  ctx.fillStyle = '#242251'; ctx.font = '900 116px Impact, sans-serif'; ctx.fillText('CLOSEOUT', 42, 196);
  ctx.fillStyle = '#242251'; ctx.font = '900 43px Impact, sans-serif'; ctx.fillText('PASS. GATHER.', 50, 274);
  ctx.fillText('BEAT THE HAND.', 50, 326);
  ctx.fillStyle = '#fff6dc'; ctx.fillRect(48, 370, 430, 75);
  ctx.fillStyle = '#242251'; ctx.font = '800 28px Inter, sans-serif'; ctx.fillText('8 POSSESSIONS · DAILY', 72, 418);
  ctx.fillStyle = '#fff6dc'; ctx.fillRect(44, 525, 420, 55);
  ctx.fillStyle = '#242251'; ctx.font = '800 25px Inter, sans-serif'; ctx.fillText('closeout.playkeg.com', 64, 561);

  document.body.innerHTML = '';
  document.body.style.margin = '0';
  document.body.style.background = '#f4ad72';
  document.body.append(canvas);
  document.title = 'og-ready';
}

function drawPlayer(ctx: CanvasRenderingContext2D, x: number, y: number, color: string, contest: boolean): void {
  ctx.save(); ctx.translate(x, y); ctx.strokeStyle = '#242251'; ctx.lineCap = 'round';
  ctx.lineWidth = 24; ctx.beginPath(); ctx.moveTo(-20, 45); ctx.lineTo(-50, 125); ctx.moveTo(20, 45); ctx.lineTo(55, 125); ctx.stroke();
  ctx.fillStyle = color; ctx.lineWidth = 8; ctx.beginPath(); ctx.moveTo(-55, -50); ctx.quadraticCurveTo(0, -75, 55, -50); ctx.lineTo(42, 50); ctx.quadraticCurveTo(0, 72, -42, 50); ctx.closePath(); ctx.fill(); ctx.stroke();
  ctx.fillStyle = '#fff6dc'; ctx.beginPath(); ctx.arc(0, -100, 34, 0, Math.PI * 2); ctx.fill(); ctx.stroke();
  ctx.lineWidth = 22; ctx.beginPath(); ctx.moveTo(-45, -34); ctx.lineTo(-95, contest ? -130 : 10); ctx.moveTo(45, -34); ctx.lineTo(105, contest ? -160 : -10); ctx.stroke();
  ctx.strokeStyle = color; ctx.lineWidth = 10; ctx.beginPath(); ctx.moveTo(-45, -34); ctx.lineTo(-95, contest ? -130 : 10); ctx.moveTo(45, -34); ctx.lineTo(105, contest ? -160 : -10); ctx.stroke();
  ctx.restore();
}

function drawBall(ctx: CanvasRenderingContext2D, x: number, y: number, r: number): void {
  ctx.fillStyle = '#ff7548'; ctx.strokeStyle = '#242251'; ctx.lineWidth = 7; ctx.beginPath(); ctx.arc(x, y, r, 0, Math.PI * 2); ctx.fill(); ctx.stroke();
  ctx.beginPath(); ctx.moveTo(x - r, y); ctx.lineTo(x + r, y); ctx.stroke();
  ctx.beginPath(); ctx.ellipse(x, y, r * .45, r, 0, 0, Math.PI * 2); ctx.stroke();
}
